<p-confirmDialog class="delete_bill_related_dialog"></p-confirmDialog>
<div class="display-bills-tabs">
  <div class="d-flex justify-content-end">
    <button *ngIf="!splitActive" class="split_bill_btn m-2" (click)="initializeBillSplit()" [disabled]="activeIndex != 0 || !checkSplitEnabled()">
      {{translate.instant('ORDER_BILL.SPLIT') }}</button>
    <button *ngIf="splitActive" class="split_bill_btn m-2" (click)="finishBillSplit()" [disabled]="activeIndex != 0 || !checkSplitEnabled()">
        {{translate.instant('SAVE') }}</button>
    <ng-container *ngIf="splitActive">
      <button class="cancel_split_btn m-2" (click)="cancelSplit()">{{'CANCEL' | translate }}</button>
    </ng-container>
  </div>
  <p-tabView *ngIf="orderBill" #tabView (onClose)="deleteOrderBill($event, tabView)" [controlClose]="true" (onChange)="changeTab($event, tabView)" [(activeIndex)]="activeIndex">
    <p-tabPanel [header]="'#' + orderBill.billNumber" [closable]="orderBillDeleteEnabled(orderBill)"  [selected]="activeIndex == 0" >
      <div class="table_items_display w-100">
        <ng-container *ngIf="splitActive; then splitBillForm; else displayBill">
        </ng-container>
      </div>
    </p-tabPanel>

    <ng-container *ngIf="orderBill.orderBills.length > 0">
      <p-tabPanel [header]="'#' + splitBill.billNumber" [closable]="orderBillDeleteEnabled(splitBill)" *ngFor="let splitBill of orderBill.orderBills; let i = index" [selected]="i == (activeIndex - 1)" >
        <div class="table_items_display w-100">
          <ng-container *ngTemplateOutlet="displayBill">
          </ng-container>
        </div>
      </p-tabPanel>
    </ng-container>

    <div class="footer_wrapper">
        <div *ngIf="!(splitActive && activeIndex == 0) " class="d-flex justify-content-end">
          <span class="display_total"> {{'ORDER_DETAILS.TOTAL' | translate}} {{selectedBill.priceWithTax | customCurrencyPipe: selectedBill.currencyShortName :'1.0-2'}}</span>
        </div>
        <div *ngIf="!splitActive" class="d-flex justify-content-end">
          <p-dropdown id="print_dropdown"  [(ngModel)]="selectedPrinter" (onChange)="printBill()" [disabled]="!checkPrintEnabled()" [options]="printerOptions"
                       placeholder="{{'ORDER_BILL.PRINT' | translate | uppercase}}"
                       [showClear]="false" optionLabel ="label">
            <ng-template let-printer pTemplate="item">
              <span>{{printer.label | translate }}</span>
            </ng-template>
            <ng-template let-printer pTemplate="selectedItem">
              <span>{{printer.label | translate }}</span>
            </ng-template>
          </p-dropdown>
          <button class="pay_btn" (click)="openPaymentDialog()" [disabled]="!checkPaymentEnabled()">{{'ORDER_BILL.PAY' | translate | uppercase}}</button>
        </div>
      </div>
  </p-tabView>
</div>
<ng-template #displayBill>
      <div class="items_table_content_wrapper">
        <div *ngFor="let item of selectedBill.items">
          <div class="list_item d-flex flex-row justify-content-between">
            <span>{{item.venueMenuItemName}}</span>
            <span>{{item.totalQuantity}}
            <button class="delete_item_bill_btn" [disabled]="!orderBillChangeItemsEnabled(selectedBill) || item.totalQuantity <= 0" (click)="deleteOrderBillItem(item)"><i class="pi pi-trash"></i></button>
          </span>
          </div>
        </div>
      </div>
      <div class="discount_group d-flex flex-row justify-content-end">
        <span class="discount_label">{{'ORDER_BILL.DISCOUNT' | translate | uppercase}}</span>
        <input class="discount_input" [disabled]="selectedBill.discount != null || selectedBill.discountPercentage != null" [(ngModel)]="discountValue">
        <p-selectButton [options]="typeOfDiscount" [disabled]="selectedBill.discount != null || selectedBill.discountPercentage != null" [(ngModel)]="selectedTypeOfDiscount" optionLabel="label"></p-selectButton>
      </div>
      <div class="items_list_footer d-flex flex-row justify-content-end">{{'ORDER_DETAILS.TOTAL' | translate}} {{selectedBill.price | customCurrencyPipe: selectedBill.currencyShortName :'1.0-2'}}</div>
</ng-template>

<ng-template #splitBillForm>
    <div class="items_table_content_wrapper">
      <ng-container  *ngFor="let item of newSplitBillItems">
        <div class="list_item d-flex flex-row justify-content-between">
          <span>
            <input class="mx-1" type="checkbox" (click)="selectItem(item)" >
            {{item.venueMenuItemName}}
          </span>
          <div class="d-flex justify-content-center">
            <button class="decrease_quantity_btn" [disabled]="item.totalQuantity <= 0" (click)="item.totalQuantity = item.totalQuantity - 1">-</button>
            <div class="input_quantity">{{item.totalQuantity}}</div>
            <button class="increase_quantity_btn" (click)="increaseNumberOfItemsInSplitBill(item)">+</button>
          </div>
        </div>
      </ng-container>
    </div>
</ng-template>
